import React from 'react';
import styled from 'astroturf/react';
import { Modal } from 'js/design_system/Modal';
import { ShareButtons } from './ShareButtons';

const Title = styled.h1`
  @import 'stylesheets/design_system/font';
  @import 'stylesheets/design_system/breakpoint';
  @include sans-serif__medium;
  text-align: center;
  margin-bottom: var(--spacing-xs-8, 8px);

  @include breakpoint(medium, large) {
    @include sans-serif__large;
    margin-bottom: var(--spacing-xs-8, 8px);
  }
`;

const Content = styled.div`
  @import 'stylesheets/design_system/font';
  @import 'stylesheets/design_system/breakpoint';
  @include body__small;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md-40, 40px);
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
  }

  @include breakpoint(medium, large) {
    @include body__medium;
    color: var(--text-secondary);
    margin-bottom: var(--spacing-md-40, 40px);
    max-width: 700px;
  }
`;

const ModalShareButtonsWrapper = styled('div')`
  & button,
  & a {
    width: auto !important;
    flex: 0 0 auto !important;
  }
`;

type ShareModalProps = {
  open: boolean;
  publishedLetter: {
    id: string | number;
    doi: string;
    work: {
      id: string | number;
      title: string;
      owner: {
        first_name: string;
        last_name: string;
      };
    };
    letter_submission: {
      authors: Array<{
        first_name: string;
        last_name: string;
      }>;
    };
    journal: {
      name: string;
    };
  };
  onClose: () => void;
  source: string;
};

const ShareModal: React.FC<ShareModalProps> = ({
  open,
  publishedLetter,
  onClose,
  source,
}) => {
  const paperUrl = `https://doi.org/${publishedLetter.doi}`;

  // Create a submission-like object for ShareButtons
  const submission = {
    id: publishedLetter.id,
    journal_name: publishedLetter.journal.name,
    authors: publishedLetter.letter_submission.authors,
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Title>Share article</Title>
      <Content>
        <p>Share this article with your peers and academic community.</p>
        <ModalShareButtonsWrapper>
          <ShareButtons
            submission={submission}
            paperUrl={paperUrl}
            source={source}
          />
        </ModalShareButtonsWrapper>
      </Content>
    </Modal>
  );
};

export default ShareModal;
